document.addEventListener('DOMContentLoaded', () => {

  const overlay  = document.getElementById('playlist-modal-overlay');
  const btnOpen  = document.getElementById('btn-open-playlist-modal');
  const btnClose = document.getElementById('btn-close-playlist-modal');
  const overlayDesktopPlayList  = document.getElementById('playlist-submit');

  function openModal() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
    overlayDesktopPlayList.classList.add('is-open-mobile');
  }
  function closeModal() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
    overlayDesktopPlayList.classList.remove('is-open-mobile');
  }

  if (btnOpen)  btnOpen.addEventListener('click', openModal);
  if (btnClose) btnClose.addEventListener('click', closeModal);
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal();
    });
  }

  // ── DESKTOP modal (lightbox) ─────────────────────────────
  const overlayDesktop  = document.getElementById('playlist-modal-overlay-desktop');
  const btnOpenDesktop  = document.getElementById('btn-open-playlist-modal-desktop');
  const btnCloseDesktop = document.getElementById('btn-close-playlist-modal-desktop');

  function openModalDesktop() {
    overlayDesktop.classList.add('is-open');
    btnOpenDesktop.classList.add('is-open');
    overlayDesktopPlayList.classList.add('is-open');
    overlayDesktop.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
  }
  function closeModalDesktop() {
    overlayDesktop.classList.remove('is-open');
      btnOpenDesktop.classList.remove('is-open');
    overlayDesktopPlayList.classList.remove('is-open');
    overlayDesktop.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  }

  if (btnOpenDesktop)  btnOpenDesktop.addEventListener('click', openModalDesktop);
  if (btnCloseDesktop) btnCloseDesktop.addEventListener('click', closeModalDesktop);
  if (overlayDesktop)  overlayDesktop.addEventListener('click', (e) => { if (e.target === overlayDesktop) closeModalDesktop(); });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModalDesktop(); });


  /* ── Utilidades de validación ── */

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function isValidSpotify(value) {
    return value.includes('open.spotify.com/playlist/');
  }

  function showError(input, message) {
    input.classList.add('input-error');
    let errorEl = input.parentElement.querySelector('.field-error');
    if (!errorEl) {
      errorEl = document.createElement('span');
      errorEl.className = 'field-error';
      input.parentElement.appendChild(errorEl);
    }
    errorEl.textContent = message;
  }

  function clearError(input) {
    input.classList.remove('input-error');
    const errorEl = input.parentElement.querySelector('.field-error');
    if (errorEl) errorEl.textContent = '';
  }

  function validateEmail(input) {
    const value = input.value.trim();
    if (value && !isValidEmail(value)) {
      showError(input, 'Enter a valid email address.');
      return false;
    }
    clearError(input);
    return true;
  }

  function validateSpotify(input) {
    const value = input.value.trim();
    if (value && !isValidSpotify(value)) {
      showError(input, 'Must be a valid Spotify playlist link (open.spotify.com/playlist/...)');
      return false;
    }
    clearError(input);
    return true;
  }

  /* ── Inicializar validación por formulario ── */

  function initForm(formId, successId) {
    const form = document.getElementById(formId);
    if (!form) return;

    const successMessage = document.getElementById(successId);
    const submitButton   = form.querySelector('button[type="submit"]');

    const emailInput   = form.querySelector('input[name="email"]');
    const spotifyInput = form.querySelector('input[name="spotify_url"]');

    /* Validación al salir del campo (blur) */
    if (emailInput) {
      emailInput.addEventListener('blur', () => validateEmail(emailInput));
      emailInput.addEventListener('input', () => {
        if (emailInput.classList.contains('input-error')) validateEmail(emailInput);
      });
    }

    if (spotifyInput) {
      spotifyInput.addEventListener('blur', () => validateSpotify(spotifyInput));
      spotifyInput.addEventListener('input', () => {
        if (spotifyInput.classList.contains('input-error')) validateSpotify(spotifyInput);
      });
    }

    /* Submit */
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const formData = new FormData(form);
      const data = {
        playlist_title:       formData.get('playlist_title')?.trim()       || '',
        spotify_url:          formData.get('spotify_url')?.trim()          || '',
        recommended_activity: formData.get('recommended_activity')?.trim() || '',
        recommended_dose:     formData.get('recommended_dose')?.trim()     || '',
        name:                 formData.get('name')?.trim()                 || '',
        email:                formData.get('email')?.trim()                || ''
      };

      /* Validar campos requeridos */
      let isValid = true;

      const playlistInput = form.querySelector('input[name="playlist_title"]');
      if (!data.playlist_title && playlistInput) {
        showError(playlistInput, 'Playlist title is required.');
        isValid = false;
      } else if (playlistInput) {
        clearError(playlistInput);
      }

      if (!data.spotify_url && spotifyInput) {
        showError(spotifyInput, 'Spotify link is required.');
        isValid = false;
      } else if (spotifyInput && !isValidSpotify(data.spotify_url)) {
        showError(spotifyInput, 'Must be a valid Spotify playlist link (open.spotify.com/playlist/...)');
        isValid = false;
      } else if (spotifyInput) {
        clearError(spotifyInput);
      }

      if (data.email && emailInput && !isValidEmail(data.email)) {
        showError(emailInput, 'Enter a valid email address.');
        isValid = false;
      } else if (emailInput) {
        clearError(emailInput);
      }

      if (!isValid) return;

      /* Envío */
      const originalText = submitButton.innerText;
      try {
        submitButton.disabled  = true;
        submitButton.innerText = 'SENDING...';

        await fetch(
          'https://script.google.com/macros/s/AKfycbxlTEJx1g0-9MNG4nTtXXGXjlb_Pd-5WjXeWGAXZ2elY-U0f_XB5hDt6_peRGM3CkA7/exec?token=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',
          { method: 'POST', mode: 'no-cors', body: JSON.stringify(data) }
        );
      } catch (_) {
        /* no-cors siempre lanza — tratamos como éxito igual */
      } finally {
        submitButton.disabled  = false;
        submitButton.innerText = originalText;
      }

      form.reset();
      form.style.display = 'none';
      if (successMessage) successMessage.hidden = false;
    });
  }

  initForm('playlist-form-desktop', 'success-msg-desktop');
  initForm('playlist-form-mobile',  'success-msg-mobile');
});